import React from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import { userService } from "../../services/userService";

const useStyles = makeStyles(theme => ({}));

const SignOut = props => {
    const { history } = props;
    console.log('ten ten ten');
    const classes = useStyles();
    userService.logout();
    history.push("/sign-in");
    return <div className={classes.root} > Good bye! </div>;
};

SignOut.propTypes = {
    history: PropTypes.object
};

export default withRouter(SignOut);